
import { components } from '~/slices'

export default {
  name: 'IndexPage',
  async asyncData({ app, $prismic, error }) {
    try {
      const document = await $prismic.api.getSingle('homepage', {
        lang: app.i18n.localeProperties.prismic,
      })

      if (document) {
        return { document: document.data }
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  data() {
    return { components }
  },
  methods: {
    getSafeLink(linkField, fallback) {
      if (!linkField) return fallback
      if (linkField.url && linkField.url.trim() !== '') return linkField.url
      if (linkField.uid) return `/${linkField.uid}/`
      if (linkField.slug) return `/${linkField.slug}/`
      return fallback
    }
  },
  computed: {
    heroVideoPoster() {
      return this.document && this.document.hero_video_poster
        ? this.document.hero_video_poster.url
        : ''
    },
  },
  head() {
    if (!this.document) return {}

    const i18nHEAD = this.$nuxtI18nHead({ addSeoAttributes: true })

    i18nHEAD.link = i18nHEAD.link.map((link) => {
      if (link.href && !link.href.endsWith('/')) {
        link.href = link.href + '/'
      }
      return link
    })

    // 1. ORGANIZATION SCHEMA (Erklärt der KI, wer ATHLYZER ist)
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': 'ATHLYZER GmbH',
      'url': 'https://www.athlyzer.com/',
      'logo': 'https://www.athlyzer.com/logo.png',
      'foundingDate': '2017',
      'description': 'Cloudbasierte Videoanalyse-Software für Sportvereine und Trainer:innen.',
      'sameAs': [
        'https://www.instagram.com/athlyzer/',
        'https://www.facebook.com/Athlyzer/',
        'https://www.linkedin.com/company/athlyzer'
      ]
    }

    // 2. WEBSITE SCHEMA (Fördert die Sitelinks Searchbox in Google)
    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      'name': 'ATHLYZER Videoanalyse',
      'url': 'https://www.athlyzer.com/',
      'potentialAction': {
        '@type': 'SearchAction',
        'target': 'https://www.athlyzer.com/blog?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    }

    return {
      title: this.document.meta_titel,
      htmlAttrs: {
        ...i18nHEAD.htmlAttrs,
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.document.meta_description || '',
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.document.meta_titel || '',
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.document.meta_description || '',
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content: this.document.meta_open_graph_image ? this.document.meta_open_graph_image.url : '',
        },
        ...i18nHEAD.meta,
      ],
      link: [...i18nHEAD.link],
      script: [
        { hid: 'jsonld-org', type: 'application/ld+json', json: organizationSchema },
        { hid: 'jsonld-website', type: 'application/ld+json', json: websiteSchema }
      ]
    }
  },
}
